// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kw40","textarea":"styles_textarea__1frNK"};